import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tempStoredclientId: null,
    tempStoredConnectorIP: null,
    chatInterface: {
        interfaceKey: "",
        chatInitialized: false,
        showConversation: false,
    },
    innspireOneConfigs: {
        api_key: null,
        api_url: null
    },
};

const appPreservedConfigSlice = createSlice({
    name: 'appPreservedConfig',
    initialState,
    reducers: {
        resetAppPreservedConfig: (state) => ({
            ...initialState,
            tempStoredclientId: state.tempStoredclientId,
            tempStoredConnectorIP: state.tempStoredConnectorIP,
        }),
        setTempStoreConnectorIP: (state, action) => {
            state.tempStoredConnectorIP = action.payload
        },
        setTempStoredClientId: (state, action) => {
            state.tempStoredclientId = action.payload
        },
        setChatInterface: (state, action) => {
            state.chatInterface = {...state.chatInterface, ...action.payload}
        },
        setInnspireOneConfigs: (state, action) => {
            state.innspireOneConfigs = { ...state.innspireOneConfigs, ...action.payload };
        },
    }
});


export const { resetAppPreservedConfig, setTempStoreConnectorIP, setTempStoredClientId, setChatInterface, setInnspireOneConfigs } = appPreservedConfigSlice.actions;

export default appPreservedConfigSlice.reducer;
